import { ContentCardVariant } from '@/components/organisms/ContentCard';
import { Chapter } from '@/lib/contexts/media-controller/util';

import type { PersonalPlaylist } from '@/lib/api';

export enum CardVariations {
  BASIC = 'basic',
  DETAILED = 'detailed',
}

export enum ContentTypeVariations {
  AUDIO = 'audio',
  VIDEO = 'video',
  PLAYLIST = 'playlist',
  ARTICLE = 'article',
  ALBUM = 'album',
  PODCAST = 'podcast',
  PERSONAL_PLAYLIST = 'personal_playlist',
  COLLECTION = 'collection',
  LIBRARY = 'library',
  FAVORITE_PLAYLIST = 'favorite_playlist',
  RECENT_PLAYLIST = 'recent_playlist',
  QUIZ = 'quiz',
  GAME = 'game',
  GALLERY = 'gallery',
}

export type CardDataType = {
  episodeIndex?: number;
  id: string | number;
  contentType?: ContentTypeVariations | string;
  title: string;
  description?: string;
  imageUrl: string;
  variant: ContentCardVariant;
  rawData?: { id: string; chapters: Chapter[] } | PersonalPlaylist;
  fetchPersonalPlaylistWithTracks?: (
    playlistId: string | number,
  ) => Promise<PersonalPlaylist | null>;
};

export type CarouselVariant = 'default' | 'fade' | 'coverflow' | 'cube';

export interface CardCarouselProps {
  items: CardDataType[];
  variant: CarouselVariant;
  title: string;
  showAllURL?: string;
  hideTitle?: boolean;
}
